export default __webpack_public_path__ + "static/error-3e31559d5a3f4c1c7f59c3f99b19f28f.svg";